import { MaterialIcon } from "@website/icons/material";
import { Avatar } from "@website/ui/avatar";
import { Sheet } from "@website/ui/sheet";
import { numberConvert } from "@website/utils/number-convert";
import { FC, memo, useEffect } from "react";
import profileImage from "../../assets/avatar.svg";
import { ProfileMenuItem } from "./components/profile-menu-item";
import { useProfileMenu } from "./profile-menu.hook";
import { ProfileMenuPropertiesType } from "./profile-menu.types";

const ProfileMenu: FC<ProfileMenuPropertiesType> = ({
  balance,
  isLoadingGetBalance,
  isHomePage
}) => {
  const {
    fullname,
    onProfileMenuClose,
    onProfileMenuOpen,
    phoneNumber,
    profileList,
    profileMenuIsOpen
  } = useProfileMenu(isHomePage, balance, isLoadingGetBalance);

  useEffect(() => {
    const handleOpenEvent = () => {
      onProfileMenuOpen();
    };
    document.addEventListener("openProfileMenu", handleOpenEvent);
    return () => {
      document.removeEventListener("openProfileMenu", handleOpenEvent);
    };
  }, [onProfileMenuOpen]);

  return (
    <Sheet
      onClose={onProfileMenuClose}
      open={profileMenuIsOpen}
      xGap="16px"
      xPosition="end"
      yPosition="end"
    >
      <div className="min-w-[312px] py-3">
        <a
          href="/profile/information"
          className="flex items-center gap-4 px-6 py-2"
        >
          <Avatar
            src={profileImage.src}
            className="size-12 max-h-12 min-w-12"
            size="large"
            type="image"
            variant="circular"
          />
          <div>
            <div className="text-subtitle-2 text-on-surface-high-emphasis">
              {fullname || "نام کاربری"}
            </div>
            <p className="text-extra-caption text-on-surface-high-emphasis">
              {numberConvert(phoneNumber?.replaceAll?.("+98", "0"), {
                locale: "fa"
              })}
            </p>
          </div>
          <MaterialIcon
            name="chevron_left"
            onClick={onProfileMenuClose}
            className="mr-auto"
          />
        </a>
        {profileList?.map((item) => (
          <ProfileMenuItem key={item.label} {...item} />
        ))}
      </div>
    </Sheet>
  );
};

const ProfileMenuMemoized = memo(ProfileMenu);
export { ProfileMenuMemoized as ProfileMenu };
